module.exports = __webpack_public_path__ + "static/img/noImage.c267947.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/theme/noImage.png
// module id = Qg0Y
// module chunks = 1